import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const selectMenuStore = (state) => state.navbarMenu;

const makeSelectSidebar = () => createSelector(
  selectMenuStore,
  ({ navbarMenuItems }) => navbarMenuItems,
);

const makeSelectOpenedSidebar = () => createSelector(
  selectMenuStore,
  ({ openedSidebar }) => openedSidebar,
);

const makeSelectDropdownItems = () => createSelector(
  selectMenuStore,
  ({ dropdownItems }) => dropdownItems,
);

const makeSelectSubmenusStatus = () => createSelector(
  selectMenuStore,
  ({ subMenus }) => subMenus,
);


export {
  selectMenuStore,
  makeSelectSidebar,
  makeSelectOpenedSidebar,
  makeSelectDropdownItems,
  makeSelectSubmenusStatus,
};
